// BILL pins each organization to one of two numbered app pods per environment (app01/app02 in
// production, app-stage01/02 in the sandbox), and a link on the wrong pod redirects to the org's own
// pod, via login and back if the user isn't signed in. So one fixed host per environment works.
//
// Only an explicit production build gets the production host. Unlike utilities/api.js, an unset
// REACT_APP_ENVIRONMENT (local development) is NOT treated as production here: local links go to the
// sandbox. The production deploy workflow sets REACT_APP_ENVIRONMENT=production explicitly.
const PRODUCTION_HOST = 'https://app.bill.com';
const SANDBOX_HOST = 'https://app-stage01.us.bill.com';

export const billcomAppHost = (env = process.env.REACT_APP_ENVIRONMENT) =>
    env === 'production' ? PRODUCTION_HOST : SANDBOX_HOST;

// /neo/bills/{id} is BILL's current web-app route for a bill. The path is case-sensitive.
export const buildBillcomBillUrl = (invoice, env) => {
    const billId = invoice?.billcom_bill_id;
    if (!billId) return null;
    return `${billcomAppHost(env)}/neo/bills/${encodeURIComponent(billId)}`;
};
